export var ALCOR_MARKET;
(function (ALCOR_MARKET) {
    ALCOR_MARKET[ALCOR_MARKET["AETHER"] = 29] = "AETHER";
    ALCOR_MARKET[ALCOR_MARKET["WECAN"] = 41] = "WECAN";
    ALCOR_MARKET[ALCOR_MARKET["CAPON"] = 43] = "CAPON";
    ALCOR_MARKET[ALCOR_MARKET["ENEFT"] = 45] = "ENEFT";
    ALCOR_MARKET[ALCOR_MARKET["WAXON"] = 42] = "WAXON";
})(ALCOR_MARKET || (ALCOR_MARKET = {}));
